'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Hoverable;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _Functions = require('../core/Functions');

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Wrapper to add a class to the given node on hover,
 * and remove it after mouse leave.
 */
function Hoverable(Component) {
  var HoverableComponent = _react2.default.createClass({
    displayName: 'Hoverable(' + (0, _reactUtils.getComponentName)(Component) + ')',

    propTypes: _extends({}, Component.propTypes, {
      children: _react.PropTypes.node,
      className: _react.PropTypes.string,
      hovered: _react.PropTypes.bool,
      onHoveredChange: _react.PropTypes.func,
      onMouseEnter: _react.PropTypes.func,
      onMouseLeave: _react.PropTypes.func
    }),

    getDefaultProps: function getDefaultProps() {
      return _extends({}, Component.defaultProps, {
        hovered: false
      });
    },
    copyMethods: function copyMethods(wrappedInstance) {
      var _this = this;

      // Copy all methods from the wrapped component instance to this wrapper,
      // so that this wrapper is usable as a ref.
      if (!wrappedInstance) {
        return;
      }
      Object.getOwnPropertyNames(wrappedInstance).forEach(function (key) {
        if (typeof wrappedInstance[key] === 'function' && !_this[key]) {
          _this[key] = wrappedInstance[key];
        }
      });
    },
    triggerHoveredChange: function triggerHoveredChange(newHovered) {
      var onHoveredChange = this.props.onHoveredChange;

      onHoveredChange((0, _SyntheticEvent2.default)(newHovered));
    },
    handleMouseEnter: function handleMouseEnter(evt) {
      this.triggerHoveredChange(true);
      (0, _Functions.callIfPossible)(this.props.onMouseEnter, evt);
    },
    handleMouseLeave: function handleMouseLeave(evt) {
      this.triggerHoveredChange(false);
      (0, _Functions.callIfPossible)(this.props.onMouseLeave, evt);
    },
    render: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          hovered = _props.hovered,
          __onHoveredChange = _props.onHoveredChange,
          __onMouseEnter = _props.onMouseEnter,
          __onMouseLeave = _props.onMouseLeave,
          rest = _objectWithoutProperties(_props, ['children', 'className', 'hovered', 'onHoveredChange', 'onMouseEnter', 'onMouseLeave']);

      return _react2.default.createElement(
        Component,
        _extends({}, rest, {
          className: (0, _reactUtils.classNames)(className, 'private-hoverable', {
            'private-hovered': hovered
          }),
          hovered: hovered,
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave,
          ref: this.copyMethods
        }),
        children
      );
    }
  });

  HoverableComponent = (0, _Controllable2.default)(HoverableComponent, ['hovered']);
  HoverableComponent.WrappedComponent = Component;
  HoverableComponent.CoreComponent = (0, _utils.getCoreComponent)(Component);

  return HoverableComponent;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/decorators/Hoverable.js
// module id = 236
// module chunks = 0 1